export default __webpack_public_path__ + "static/media/diary.923b91a7.jpeg";